export default "__VITE_ASSET__DfsMzc7$__"